// import geofencesActions from '@state/geofences/actions';
// import * as defaultAlarms from '@pages/Alertas/helpers/defaultAlerts/alertsNames';

import constants from './constants';

// const initOrCondition = {
//   type: 'numeric_threshold',
//   params: {},
// };

const setCreateEditFirmwares = (values) => (dispatch) => {

  dispatch({
    type: constants.SET_CREATE_EDIT_FIRMWARES,
    payload: values,
  });

};

const setFirmwaresIdEdit = (values) => (dispatch) => {

  dispatch({
    type: constants.SET_FIRMWARES_ID_TO_EDIT,
    payload: values,
  });

};

export default {
  setCreateEditFirmwares,
  setFirmwaresIdEdit,
};
